import { IUserProfile, ISignInState } from '../state';
import { DOMESTIC_CUSTOMER, INTERNATIONAL_CUSTOMER } from '../common';

function getBusinessUnit(profile: IUserProfile) {
    const companyId = profile && (profile.companyId || profile.defaultCompanyId);
    return (companyId && companyId.length >= 5 && companyId.length <= 8) ?
        INTERNATIONAL_CUSTOMER : DOMESTIC_CUSTOMER;
}

export const isDomestic = (profile: IUserProfile) => {
    return getBusinessUnit(profile) === DOMESTIC_CUSTOMER;
};

export const isInternational = (profile: IUserProfile) => {
    return getBusinessUnit(profile) === INTERNATIONAL_CUSTOMER;
};

// tslint:disable-next-line: no-any
export const isInternationalUser = (signIn: ISignInState | any) => {
    const companyId = (signIn &&
        signIn.user &&
        signIn.user.oauth &&
        signIn.user.oauth.profile &&
        signIn.user.oauth.profile.companyId &&
        signIn.user.oauth.profile.companyId !== 'undefined') ?
        signIn.user.oauth.profile.companyId : false;
    const cidn = companyId ? companyId : (signIn && signIn.userManagement &&
        signIn.userManagement.preferences && signIn.userManagement.preferences.data &&
        signIn.userManagement.preferences.data.lastSelectedCompanies[0] &&
        signIn.userManagement.preferences.data.lastSelectedCompanies[0].cidn) ?
        signIn.userManagement.preferences.data.lastSelectedCompanies[0].cidn : false;
    return (cidn && cidn.length >= 5 && cidn.length <= 8) ?
        true : false;
};

// tslint:disable-next-line: no-any
export const isStaffUser = (signIn: ISignInState | any) => {
    try {
        return signIn.tokens.customerProfile.data.profile === 'staff_user'
    } catch (error) {
        return undefined
    }
}
